import "./Header.scss";

const Header = () => {
  return (
    <div className="header">
      <span className="text-shadow">Who Are You?</span>
    </div>
  );
};

export default Header;
